import React from 'react';
import {
  generatePath,
  matchPath,
  RouteComponentProps,
  withRouter,
} from 'react-router';
import { getQuestionnaireByNameHook } from '../../../../apis/questionnaire';
import { getQuestionnaireResponseByReference } from '../../../../apis/questionnaireResponse';
import { PatientValuesCardComponent } from '../../../../components/Cards';
import { usePatient } from '../../../../contexts/patient';
import { IQuestionnaire } from '../../../../modules/unsw-fhir/Questionnaire';
import { IQuestionnaireResponse } from '../../../../modules/unsw-fhir/QuestionnaireResponse';
import { useDataApi } from '../../../../modules/unsw-hooks';

const PatientValuesCard = (props: RouteComponentProps<{}>) => {
  const { patient, isActive } = usePatient();
  const patientId = patient && patient.id;

  const match = matchPath<{ organizationId: string; patientId: string }>(
    props.location.pathname,
    {
      path: '/organization/:organizationId/patient/:patientId',
    },
  );

  const organizationId = match ? match.params.organizationId : undefined;
  const [{ data: questionnaire, isLoading: isQuestionnaireLoading }] =
    useDataApi<IQuestionnaire | undefined>(
      getQuestionnaireByNameHook,
      undefined,
      'patient_values',
    );

  const [
    { data: questionnaireResponse, isLoading: isQuestionnaireResponseLoading },
  ] = useDataApi<IQuestionnaireResponse | undefined>(
    getQuestionnaireResponseByReference,
    undefined,
    patientId,
    questionnaire ? questionnaire.id : undefined,
  );

  const params = {
    patientId: patientId!,
    organizationId: organizationId!,
    questionnaireResponseId: questionnaireResponse?.id!,
  };

  const viewPath = questionnaireResponse
    ? generatePath(
        '/organization/:organizationId/patient/:patientId/questionnaireResponse/:questionnaireResponseId',
        params,
      )
    : undefined;
  const editPath = questionnaireResponse
    ? generatePath(
        '/organization/:organizationId/patient/:patientId/questionnaireResponse/:questionnaireResponseId/edit',
        params,
      )
    : undefined;
  const newPath = patientId
    ? generatePath(
        '/organization/:organizationId/patient/:patientId/newQuestionnaireResponse/patient_values',
        params,
      )
    : undefined;
  return (
    <PatientValuesCardComponent
      created={questionnaireResponse && questionnaireResponse.authored}
      viewPath={viewPath}
      editPath={editPath}
      newPath={newPath}
      loading={isQuestionnaireLoading || isQuestionnaireResponseLoading}
      disabled={!isActive()}
    />
  );
};

export default withRouter(PatientValuesCard);
